import React, { Suspense } from 'react';
import { useParams } from 'react-router-dom';
import './player-shared.css';

function Loading() {
  return <div className="player-big-message">Laden...</div>;
}

export default function Player() {
  let { project } = useParams();
  let component;
  if (project === 'edubox') {
    const Player = React.lazy(() => import('./edubox'));
    component = <Player project={project} />;
  } else if (project === 'pajottenland') {
    const Player = React.lazy(() => import('./pajottenland'));
    component = <Player project={project} />;
  } else if (project === 'zaventem') {
    const Player = React.lazy(() => import('./zaventem'));
    component = <Player project={project} />;
  } else {
    component = <div className="player-big-message">Page not found.</div>;
  }

  return <Suspense fallback={<Loading />}>{component}</Suspense>;
}
